import { useQuery } from "@apollo/client/react";

import { inbox } from "./inbox.graphql";
import { inboxQueryVariables, type InboxQueryVariables } from "./query";

type WaitingQuery = {
  inbox?: { total?: number | null } | null;
};

/** Sidebar badge. Same document as the list. `limit: 0` omits items on the wire; producers still run (API PR 3). */
export const useInboxWaitingCount = (enabled: boolean): number => {
  const { data } = useQuery<WaitingQuery, InboxQueryVariables>(inbox, {
    skip: !enabled,
    variables: inboxQueryVariables({
      category: "EVERYTHING",
      limit: 0,
    }),
  });
  return data?.inbox?.total ?? 0;
};
